module.exports = __webpack_public_path__ + "img/scene_tv_time_tw_big@2x.176fb002.png";